export default __webpack_public_path__ + "static/media/company_23_blue.1ad53fae.svg";